import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';

import { Panel } from '@ktr/ktr-materialui-react';
import Grid from '@material-ui/core/Grid';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import MenuBook from '@material-ui/icons/MenuBook';
import Build from '@material-ui/icons/Build';
import ContactMail from '@material-ui/icons/Mail';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Tooltip from '@material-ui/core/Tooltip';

//import imageCooler from '../../images/CoolerPHE.jpg'
import sketchCooler from '../../images/SketchPHE.jpg'

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

//import Configuration from '../../config/Config';
import { LayoutResult, LayoutInput, createUrlPDF, createShopUrl } from '../../service/ServiceAPI';

import { GAnalytics } from "@ktr/ktr-materialui-react"

import Model3D from '../ModelView/Model3D';

import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    resultstyle: {
        padding: theme.spacing(1),
    },

    gridleft: {
        //border: '1px solid red',
        //padding: theme.spacing(1),
    },
    gridright: {
        //border: '1px solid red',
        padding: theme.spacing(1),
    },

    gridleftupper: {
        //border: '1px solid green',
        padding: theme.spacing(1),
    },
    gridleftlower: {
        //border: '1px solid green',
        padding: theme.spacing(1),
    },

    gridleftlowerleft: {
        //border: '1px solid blue',
    },

    gridleftlowerright: {
        //border: '1px solid blue',
    },

    imagesketch: {
        display: 'inline-flex',
        width: '100%',
        height: 'auto',
    },

    table: {
        //minWidth: 650,
        //textTransform: 'none'
    },

    minibutton: {
        color: '#F29400'
    },    

  }),
);

interface CoolerResultProps {
    key: Number;
    inputdata: LayoutInput;
    couplingdata: LayoutResult;
}

// stateless component resp. functional component
//function CoolerResult(props: CoolerResultProps) {

const CoolerResult = (props: CoolerResultProps) => {
    //const [warningMessage, setWarningMessage] = useState<string>("");
    let warningMessage: string = "";

    const classes = useStyles();  

    //const { t, i18n } = useTranslation();
    const { t } = useTranslation();

    const openLink = (url: string) => {
        window.open(url, 'Tech. Dokumentation', 'top=100, left=20, height=800, width=600, location=no, status=no, toolbar=no, resizable=yes');
    }

    const openLinkPDF = (urlPdfPara: string) => {
        var url: string = createUrlPDF(urlPdfPara);
        window.open(url, 'Tech. Dokumentation', 'top=100, left=20, height=800, width=600, location=no, status=no, toolbar=no, resizable=yes');
    }

    //
    function createContactMail(layoutInput: LayoutInput, layoutResult?: LayoutResult | undefined) {
        let strAdressTo: string = "hydraulic@ktr.com";

        let strSubject = t('contactmail.subject');
        if(layoutResult === undefined)
            strSubject += (" " + layoutInput.phename);
        else
            strSubject += (" " + layoutResult.coolerName);
      
        let strBody = t('contactmail.para1');
        let opstring = (layoutInput.operation === 'rate' ? t('operation_rating') : t('operation_performance'));
        strBody += ("  - " + t('inputdata.operation') + ": " + opstring + " \n");
        //strBody += ("  - " + t('inputdata.operation') + ": " + layoutInput.operation + " \n");
        strBody += ("  - " + t('inputdata.tempin1') + ": " + layoutInput.inTempSide1 + " °C\n");
        strBody += ("  - " + t('inputdata.tempin2') + ": " + layoutInput.inTempSide2 + " °C\n");
        strBody += ("  - " + t('inputdata.volumeflow1') + ": " + layoutInput.volumeFlowSide1 + " l/min\n");
        strBody += ("  - " + t('inputdata.volumeflow2') + ": " + layoutInput.volumeFlowSide2 + " l/min\n");
        strBody += ("  - " + t('inputdata.fluid1') + ": " + layoutInput.fluidSide1 + " \n");
        strBody += ("  - " + t('inputdata.fluid2') + ": " + layoutInput.fluidSide2 + " \n");
        strBody += ("  - " + t('inputdata.heatdissipation') + ": " + layoutInput.heatDissipation + " kW\n");

        strBody += "\n";
        strBody += t('contactmail.contact');
        strBody += t('contactmail.name');
        strBody += t('contactmail.adress');
        strBody += t('contactmail.mail');
        strBody += t('contactmail.phone');

        strBody += t('contactmail.footer');
        
        //var strMailLink = "mailto:" + strAdressTo + "?subject=" + strSubject + "&body=" + strBody;
        var strMailLink = "mailto:" + strAdressTo + "?subject=" + encodeURIComponent(strSubject) + "&body=" + encodeURIComponent(strBody);

        return strMailLink;
    }

    //
//    const [expanded, setExpanded] = React.useState(false);
//    const handleExpandClick = () => {
//      setExpanded(!expanded);
//    };    

    //setWarningMessage("");
    warningMessage = "";
    if(props.couplingdata.pressureDrop1 > 1.0 || props.couplingdata.pressureDrop2 > 1.0) {
        //setWarningMessage(t("pressuredrop"));
        warningMessage = (t("pressuredrop"));
    }

    //const helpBox1 = (<ul><li>left: rotate</li><li>wheel: zoom</li><li>right: move</li></ul>);
    const helpBox = (<ul>
                        <li>{t('outputdata.helptext.rotate')}</li>
                        <li>{t('outputdata.helptext.zoom')}</li>
                        <li>{t('outputdata.helptext.move')}</li>
                    </ul>);

    return (
            <Panel title="">
                <Grid container className={classes.resultstyle}>
                    <Grid item xs={12}>
                        <h1>{props.couplingdata.coolerName} ({props.couplingdata.ranking})</h1>
                    </Grid>

                    <Grid container xs={12} md={6} className={classes.gridleft}>
                        <Grid item xs={12} md={12} className={classes.gridleftupper}>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{"textTransform": "none"}}>{props.couplingdata.coolerName}</TableCell>
                                            <TableCell style={{"textTransform": "none"}} align="right">{t('outputdata.singleresult.titleside1')}</TableCell>
                                            <TableCell style={{"textTransform": "none"}} align="right">{t('outputdata.singleresult.titleside2')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow key={props.couplingdata.temperatureOut1}> 
                                            <TableCell component="th" scope="row">{t('outputdata.singleresult.tempout')}</TableCell>
                                            <TableCell align="right">{t('format.formattedNumber', { number: props.couplingdata.temperatureOut1 } ) } °C</TableCell>
                                            <TableCell align="right">{t('format.formattedNumber', { number: props.couplingdata.temperatureOut2 } ) } °C</TableCell>
                                        </TableRow>
                                        <TableRow key={props.couplingdata.pressureDrop1}> 
                                            <TableCell component="th" scope="row">{t('outputdata.singleresult.pressuredrop')}</TableCell>
                                            <TableCell align="right">{t('format.formattedNumber', { number: props.couplingdata.pressureDrop1 } ) } bar</TableCell>
                                            <TableCell align="right">{t('format.formattedNumber', { number: props.couplingdata.pressureDrop2 } ) } bar</TableCell>
                                        </TableRow>
                                        <TableRow key={props.couplingdata.volumeFlow1}> 
                                            <TableCell component="th" scope="row">{t('outputdata.singleresult.volumeflow')}</TableCell>
                                            <TableCell align="right">{t('format.formattedNumber', { number: props.couplingdata.volumeFlow1 } ) } l/min</TableCell>
                                            <TableCell align="right">{t('format.formattedNumber', { number: props.couplingdata.volumeFlow2 } ) } l/min</TableCell>
                                        </TableRow>
                                        {/*
                                        <TableRow> 
                                            <TableCell component="th" scope="row">{t('outputdata.singleresult.numofchannel')}</TableCell>
                                            <TableCell align="right">{props.couplingdata.n_channel_hot}</TableCell>
                                            <TableCell align="right">{props.couplingdata.n_channel_cold}</TableCell>
                                        </TableRow>
                                        */}
                                        <TableRow> 
                                            <TableCell component="th" scope="row">{t('outputdata.singleresult.heatflow')}</TableCell>
                                            <TableCell align="center" colSpan={2}> {t('format.formattedNumber', { number: props.couplingdata.heatFlow } ) } kW</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid container className={classes.gridleftlower}>
                            <Grid item xs={12} md={7} className={classes.gridleftlowerleft}>
                                <img src={sketchCooler} alt="OAC Cooler" className={classes.imagesketch} />
                            </Grid>
                            <Grid item xs={12} md={5} className={classes.gridleftlowerright}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{"textTransform": "none"}} colSpan={2}>{t('outputdata.singleresult.dimension')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">a</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{t('format.formattedNumber', { number: props.couplingdata.geo.a} ) } mm</TableCell>
                                            </TableRow>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">b</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{t('format.formattedNumber', { number: props.couplingdata.geo.b} ) } mm</TableCell>
                                            </TableRow>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">c</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{t('format.formattedNumber', { number: props.couplingdata.geo.c} ) } mm</TableCell>
                                            </TableRow>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">d</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{t('format.formattedNumber', { number: props.couplingdata.geo.d} ) } mm</TableCell>
                                            </TableRow>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">e</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{t('format.formattedNumber', { number: props.couplingdata.geo.e} ) } mm</TableCell>
                                            </TableRow>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">f</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{t('format.formattedNumber', { number: props.couplingdata.geo.f} ) } mm</TableCell>
                                            </TableRow>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">{t('outputdata.singleresult.screwthreadA')}</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{props.couplingdata.geo.screwThreadA} ´´</TableCell>
                                            </TableRow>
                                            <TableRow> 
                                                <TableCell component="th" scope="row">{t('outputdata.singleresult.screwthreadB')}</TableCell>
                                                <TableCell align="right" style={{'whiteSpace': 'nowrap'}}>{props.couplingdata.geo.screwThreadB} ´´</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={6} className={classes.gridright}>
                        <Model3D helpbox={helpBox} material="Copper" model={props.couplingdata.coolerName}/>
                        {/*
                        <ul>
                            <li>{t('outputdata.helptext.rotate')}</li>
                            <li>{t('outputdata.helptext.zoom')}</li>
                            <li>{t('outputdata.helptext.move')}</li>
                        </ul>
                        */}
                    </Grid>

                    {
                    warningMessage !== "" ? 
                        <Grid item xs={12}>
                            <Panel title="">
                                <span style={{color: '#F29400', fontWeight: 'bold', fontSize: '150%' }}>{warningMessage}</span>
                            </Panel>
                        </Grid>
                    : null
                    }

                    <Grid item xs={12} md={12}>
                        <Tooltip title = {t('tooltip.pdf') as string}>
                            <IconButton aria-label="get pdf" className={classes.minibutton} >
                                <PictureAsPdf onClick={() => {GAnalytics.gaEvent('Cooler PDF request', 'PHE cooler layout'); openLinkPDF(props.couplingdata.urlPdf)}} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title = {t('tooltip.catalog') as string}>
                            <IconButton aria-label="share" className={classes.minibutton} >
                                <MenuBook onClick={() => {GAnalytics.gaEvent('Cooler catalog request', 'PHE cooler layout'); openLink(props.couplingdata.urlCatalog)}} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title = {t('tooltip.assembly') as string}>
                            <IconButton aria-label="share" className={classes.minibutton} >
                                <Build onClick={() => {GAnalytics.gaEvent('Cooler assembly instruction request', 'PHE cooler layout'); openLink(props.couplingdata.urlAssembly)}} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title = {t('tooltip.shop') as string}>
                            <IconButton aria-label="shop" className={classes.minibutton} >
                                <ShoppingCartIcon aria-label="Shop" onClick={() => {GAnalytics.gaEvent('Cooler shop link', 'PHE cooler layout'); window.open(createShopUrl([props.couplingdata.order.partNoCooler, props.couplingdata.order.partNoHolder] )) }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title = {t('tooltip.contact') as string}>
                            <IconButton aria-label="contactmail" className={classes.minibutton} >
                                <ContactMail onClick={() => {GAnalytics.gaEvent('Cooler mail contact', 'PHE cooler layout'); window.location.href = createContactMail(props.inputdata, props.couplingdata)}} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Panel>

    );
}

export default CoolerResult;
